import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LucideIcon } from '../../components/UI/LucideIcon';

// ── Card de novidades da equipe interna — abre sempre que alguém ENTRA em
// /adm (trocar de tela dentro do /adm não reabre; sair e voltar, sim — ver
// resetNovidadeAdm, chamado pelo App.jsx ao sair do /adm).
//
// ATIVAR_CARD_NOVIDADE: liga/desliga o card inteiro.
// NOVIDADE: o conteúdo atual. Para um comunicado novo, troque o objeto
// (data, título, intro e blocos); `rota` em um bloco vira um link que fecha o
// card e leva até a tela.
export const ATIVAR_CARD_NOVIDADE = false;

export const NOVIDADE = {
  data: '2026-10-02',
  titulo: 'Comunicados e apelido da emissão',
  intro: 'Duas novidades na área administrativa: a seção Comunicados, para controlar quem recebe aviso por e-mail de arquivo novo, e o apelido da emissão, que é o nome exibido no portal.',
  blocos: [
    {
      icon: 'megaphone',
      titulo: 'Comunicados — lista de transmissão',
      texto: 'Cadastre e-mails que recebem aviso de arquivo novo das emissões vinculadas, mesmo sem conta no portal. O Painel mostra cada par e-mail × emissão, juntando a lista e quem favoritou (Favoritos, Lista ou Ambos), com ações por linha: incluir em mais emissões, tirar de uma, renomear e encerrar.',
      rota: '/adm/comunicados', rotaLabel: 'Abrir Comunicados',
    },
    {
      icon: 'link-2',
      titulo: 'Novo contato e Vínculos em lote',
      texto: 'Cadastre um e-mail por vez ou vincule/desvincule várias emissões de vários e-mails de uma vez.',
      rota: '/adm/comunicados/lote', rotaLabel: 'Vínculos em lote',
    },
    {
      icon: 'upload',
      titulo: 'Upload: "Disparar e-mail"',
      texto: 'Cada arquivo da fila de Upload tem a opção de avisar ou não, e "Quem vai ser avisado?" mostra a prévia. Só arquivo NOVO avisa — substituir um existente não manda e-mail.',
      rota: '/adm/arquivos/novo', rotaLabel: 'Ir para o Upload',
    },
    {
      icon: 'star',
      titulo: 'Favoritos no portal',
      texto: 'Clientes com conta escolhem no próprio perfil de quais emissões favoritas e tipos querem aviso (ao favoritar, os 4 tipos já vêm ligados; a pessoa desmarca o que não quer). Quem está só na lista de transmissão recebe os 4 tipos; se também favoritou a emissão, valem os tipos que escolheu. Os e-mails saem de DoNotReply@leveragesec.com.br.',
    },
    {
      icon: 'pencil',
      titulo: 'Apelido da emissão',
      texto: 'Em Publicar no Site, a primeira publicação de uma emissão pede o apelido — o nome que aparece no portal (ex.: "33ª Emissão - Makasí"). Depois, dá para editar a qualquer momento no lápis ao lado do nome da emissão.',
      rota: '/adm/liberacao-site', rotaLabel: 'Abrir Publicar no Site',
    },
  ],
};

let novidadeFechada = false;
export function resetNovidadeAdm() { novidadeFechada = false; }

function fmtData(iso) {
  const [a, m, d] = iso.split('-');
  return `${d}/${m}/${a}`;
}

export default function NovidadesAdm() {
  const navigate = useNavigate();
  const [aberto, setAberto] = useState(() => ATIVAR_CARD_NOVIDADE && !novidadeFechada);

  function fechar() {
    novidadeFechada = true;
    setAberto(false);
  }

  useEffect(() => {
    if (!aberto) return undefined;
    const onKey = e => { if (e.key === 'Escape') { novidadeFechada = true; setAberto(false); } };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [aberto]);

  if (!aberto) return null;
  return (
    <div className="lev-overlay" onClick={fechar}>
      <div className="lev-modal" role="dialog" aria-modal="true" aria-labelledby="novidade-adm-titulo"
        style={{ maxWidth: 640 }} onClick={e => e.stopPropagation()}>
        <div className="lev-modal-bar">
          <button className="lev-modal-close" onClick={fechar} aria-label="Fechar"><LucideIcon name="x" size={18}/></button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
          <span style={{ width: 42, height: 42, borderRadius: 12, background: 'var(--gradient-brand-diag)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <LucideIcon name="lightbulb" size={20} color="#fff"/>
          </span>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--brand-purple)' }}>
              Novidade · {fmtData(NOVIDADE.data)}
            </div>
            <div id="novidade-adm-titulo" style={{ fontSize: 18, fontWeight: 700, color: 'var(--brand-indigo)', fontFamily: 'var(--font-display)', lineHeight: 1.2 }}>{NOVIDADE.titulo}</div>
          </div>
        </div>
        <p style={{ fontSize: 13.5, color: 'var(--gray-600)', lineHeight: 1.55, margin: '0 0 14px' }}>{NOVIDADE.intro}</p>

        <ul className="lev-scrollbar" style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: 10, maxHeight: '52vh', overflowY: 'auto' }}>
          {NOVIDADE.blocos.map(b => (
            <li key={b.titulo} style={{ display: 'flex', gap: 12, alignItems: 'flex-start', border: '1px solid var(--gray-200)', borderRadius: 12, padding: '12px 14px' }}>
              <span style={{ width: 32, height: 32, borderRadius: 9, background: 'rgba(52,62,131,.10)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <LucideIcon name={b.icon} size={15} color="var(--brand-indigo)"/>
              </span>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--brand-indigo)' }}>{b.titulo}</div>
                <div style={{ fontSize: 12.5, color: 'var(--gray-600)', lineHeight: 1.5, marginTop: 3 }}>{b.texto}</div>
                {b.rota && (
                  <button type="button" className="lev-link-btn" style={{ fontSize: 12.5, marginTop: 6 }}
                    onClick={() => { fechar(); navigate(b.rota); }}>
                    {b.rotaLabel} <LucideIcon name="arrow-right" size={12}/>
                  </button>
                )}
              </div>
            </li>
          ))}
        </ul>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 18 }}>
          <button type="button" className="lev-btn-primary" onClick={fechar}>Entendi</button>
        </div>
      </div>
    </div>
  );
}
